import YFormCheckboxList from './CheckboxList';

export { YFormCheckboxList };
export default YFormCheckboxList;
